import Allergens from './allergens';
import MenuNavigationBar from './MenuNavigationBar';
import CategoryItem from './CategoryItem';
import MenuList from './MenuList';
import ModifierGroup from './ModifierGroup';
import MultiSelectMenuItems from './MultiSelectMenuItems';
import NestedModifiers from './Nested/NestedModifiers';
import MenuCategoryList from './MenuCategoryList';
import Product from './product';

export default {
  Allergens,
  MenuNavigationBar,
  CategoryItem,
  MenuList,
  ModifierGroup,
  MultiSelectMenuItems,
  NestedModifiers,
  MenuCategoryList,
  Product,
};
